/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetHeaderSpotlightQuery,
  IGetHeaderSpotlightQueryVariables,
  GetHeaderSpotlightDocument,
} from './types';
import { IOfferingConnection } from '@r-client/data/graphql-types';
export type { IOfferingConnection };

export type IGetHeaderSpotlightQueryOpts =
  IQueryModelOpts<IGetHeaderSpotlightQueryVariables>;

export class GetHeaderSpotlightQuery extends BaseQueryModel<
  IGetHeaderSpotlightQuery,
  IGetHeaderSpotlightQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetHeaderSpotlightQueryOpts) {
    super(opts);
  }

  get query() {
    return GetHeaderSpotlightDocument;
  }
}
export function useGetHeaderSpotlightQuery(
  opts?: Omit<IGetHeaderSpotlightQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetHeaderSpotlightQuery({ ...opts, client }),
    opts?.variables
  );
}
